import axios from '@/http/axios';

const state = {
    companies: []
};

const mutations = {
    setCompanies (state, companies) {
      state.companies = companies;
    }
};

const actions = {
    getCompanies ({ commit }, payload) {
        return axios.get('users/company').then(response => {
            commit('setCompanies', response.data.data);
        });
    }
};

const getters = {
    companies: state => state.companies
};

export default {
    state,
    actions,
    mutations,
    getters
};